import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useMediaQuery';

const WebsiteDesign: React.FC = () => {
  const isMobile = useIsMobile();
  
  const whatWeDo = [
    {
      title: 'Building Mobile Apps',
      description: 'We create innovative mobile applications for iOS and Android, focusing on user experience and cutting-edge AI technologies.',
      icon: '📱'
    },
    {
      title: 'Developing Web Applications',
      description: 'We build powerful web applications and platforms that solve real-world problems using modern technologies and AI.',
      icon: '💻'
    },
    {
      title: 'Creating Digital Products',
      description: 'We design and develop complete digital products from concept to launch, bringing ideas to life in the B2B and B2C spaces.',
      icon: '🌐'
    }
  ];

  const MotionWrapper = ({ children, ...props }: any) => {
    if (isMobile) {
      return <div>{children}</div>;
    }
    return <motion.div {...props}>{children}</motion.div>;
  };

  return (
    <section id="services" className="bg-[#F8F6F0] py-20">
      <div className="container mx-auto px-6">
        <MotionWrapper
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-6">
            What We Do
          </h2>
          <p className="text-xl text-[#333333] max-w-3xl mx-auto leading-relaxed">
            We build innovative digital products and applications that solve real-world problems. 
            From mobile apps to web platforms, we create solutions that make a difference.
          </p>
        </MotionWrapper>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {whatWeDo.map((item, index) => (
            <MotionWrapper
              key={item.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={isMobile ? {} : { y: -10, scale: 1.02 }}
              className="bg-white rounded-xl p-8 text-center hover:bg-gray-50 transition-all duration-300 shadow-lg"
            >
              <MotionWrapper
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
                className="text-4xl mb-4"
              >
                {item.icon}
              </MotionWrapper>
              <h3 className="text-2xl font-bold text-[#333333] mb-6">{item.title}</h3>
              <p className="text-[#333333] leading-relaxed text-lg">{item.description}</p>
            </MotionWrapper>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WebsiteDesign;
